import { useEffect, useState } from 'react'
import 'primeicons/primeicons.css';
import "./index.scss"
import { LoginHomePage } from './components/loginHomepage';
import { LogoutHomePage } from './components/logoutHomepage';
import { HOMEPAGE_API_CONSTANTS, HomePageCarouselFilter, HomePageCarouselType, OfferCategoryId, viewAllUrlPaths } from './constant/hompage.constant';
import { APIEnv, APIStatus } from "../../interface/baseInterfaces"
import { getData, postData } from "../../services/global.service"
import { checkIsUserLoggedIn, createSlugByIdName, createSlugByName } from '../../utils/globalUtilities';
import { useNavigate } from 'react-router-dom';
import { RESEARCH_MAPPINGS, urlPrefix } from '../../constants/constants';
import { AppRouteURL } from '../../routes/app-route-urls';

export const HomePageIndex = () => {
    const [practicePopularTopics, setPracticePopularTopics] = useState<Array<any>>();
    const [caseLawsData, setcaseLawsData] = useState<Array<any>>();
    const [caseLawsFilterData, setcaseLawsFilterData] = useState<Array<any>>();
    const [researchTopics,setResearchTopics] = useState<Array<any>>();
    const [researchFilterData,setResearchFilterData]= useState<Array<any>>();
    const [practiceFilterData,setPracticeFilterData]= useState<Array<any>>();
    const [learningFilterData,setLearningFilterData]= useState<Array<any>>();
    const [cirnotFilterData, setCirnotFilterData] = useState<Array<any>>();
    const [CirNottData, setCirNotData] = useState<Array<any>>();
    const [learningVideosData, setlearningVideosData] = useState<Array<any>>();
    const [selectedTab, setSelectedTab] = useState<Number>(0);
    const [practiceTopicLoading, setPracticeTopicLoading] = useState<boolean>(false);
    const [caseLawsLoading, setCaseLawsLoading] = useState<boolean>(false);
    const [cirNotLoading, setCirNotLoading] = useState<boolean>(false);
    const [learningVideosLoading, setLearningVideosLoading] = useState<boolean>(false);
    const [researchSelectedSubTab,setResearchSelectedSubTab]=useState("All");
    const [practiceSelectedSubTab,setPracticeSelectedSubTab]=useState("All");
    const [learningSelectedSubTab,setLearningSelectedSubTab]=useState("All");
    const [researchGroupIds,setResearchGroupIds]=useState<any>([]);
    const [practiceGroupIds,setPracticeGroupIds]=useState<any>([]);
    const [learningGroupIds,setLearningGroupIds]=useState<any>([]);
    const navigate = useNavigate();

    // useEffect(() => {
    // if(!checkIsUserLoggedIn())
    // {
    //     navigate('/')
    //     return
    // }
    // }, [])

    useEffect(() => {
        let id: string = selectedTab == 0 ? OfferCategoryId?.ALL: ( selectedTab == 1 ? OfferCategoryId?.GST : OfferCategoryId?.INCOME_TAX);
        filterSelectedResearchTab(researchGroupIds,researchSelectedSubTab);
        filterSelectedPracticeTab(practiceGroupIds,practiceSelectedSubTab);
        filterSelectedLearningTab(learningGroupIds,learningSelectedSubTab);
    }, [selectedTab])
    
    function generateStoryUrl(data:any) {
        const categoryUrl = data.categoryUrl;
        const subCategory = data.groupUrl;
        const id = data.Id;
        const heading = data.heading;
    
        function createSlug(text:any) {
            return text
                .toLowerCase() 
                .replace(/[^\w\s-]/g, '') 
                .replace(/\s+/g, '-') 
                .replace(/^-+/, '') 
                .replace(/-+$/, ''); 
        }
    
        const headingSlug = createSlug(heading);
    
        const url = `/research/${categoryUrl}/top-story/${id}/${headingSlug}-${subCategory}`;
        
        return url;
    }
    
    function createNavigationNewTopicsURL(feedData: any): void {



        let { category, Id, heading, primaryParentTopic } = feedData;
        category = createSlugByName(category);
        heading = createSlugByName(heading);
       let primaryTopicName = primaryParentTopic[0]?.name;
       primaryTopicName = createSlugByName(primaryTopicName);
        const isRead = feedData?.groupName?.toLowerCase() == 'read'  ? 1 : 0;
        const isNullcategory = feedData.isnullcategory ? 1 : 0;
        if (isRead) {
            feedData.url = `/practice/${category}/${heading}/read/${Id}/${isRead}/${isNullcategory}`;
            feedData.params = { cat: 'read' };
        } else {
            feedData.url = `/practice/${category}/${primaryTopicName}/${heading}/${Id}/${isRead}/${isNullcategory}`;
            feedData.params = {};
        }


        return feedData;
    }

    function createNavigationURLforResearch(feedData: any) {
        let { groupUrl, categoryUrl, Id } = feedData
        if (groupUrl && categoryUrl && Id) {
            feedData.url = generateStoryUrl(feedData);
            // feedData.url = `/research/preview-document?categoryName=${categoryUrl}&fileId=${Id}&subCategory=${groupUrl}`;

        }
        return feedData;
    }

    function createNavigationURLforLearning(feedData: any) {
        let { groupName, heading, Id } = feedData
        if (groupName && heading && Id) {
            feedData.url = '/learning' + '/' + Id + '-' + createSlugByIdName(heading);
        }
        return feedData;
    }

    function getResearchTopics(filterId: any[], id: any) {
        let payload = {
            categoryId: id === "" ? [] : [id],
            groupId:filterId?[...filterId]:[]
        }
        setResearchGroupIds(filterId?[...filterId]:[]);
        setCaseLawsLoading(true);
        postData(HOMEPAGE_API_CONSTANTS.RESEARCH_TOPICS,
            payload,
            APIEnv.NODE_PREMIUM).then((response => {
                setCaseLawsLoading(false);
                if (response?.ResponseType == APIStatus.SUCCESS) {
                    let ModifiedData = response.data?.date?.itemarray.map(createNavigationURLforResearch)
                    setResearchTopics(ModifiedData);
                    setResearchFilterData(response.data?.date?.filter)
                }
            }
            )
            ).catch(err => {
                setCaseLawsLoading(false);
            })
    }
    function getPopularTopics(filterId: any[],id: any) {
        let payload = {
            categoryId: id === "" ? [] : [id],
            typeId:filterId?[...filterId]:[]
        }
        setPracticeGroupIds(filterId?[...filterId]:[]);
        setPracticeTopicLoading(true);
        
        postData(HOMEPAGE_API_CONSTANTS.GET_PRACTICE_POPUPAR_TOPICS,
            payload,
            APIEnv.NODE_PREMIUM).then((response => {
                setPracticeTopicLoading(false);

                if (response?.ResponseType == APIStatus.SUCCESS) {
                    let ModifiedData = response.data?.date?.itemarray.map(createNavigationNewTopicsURL)

                    setPracticePopularTopics(ModifiedData);
                    setPracticeFilterData(response.data?.date?.filter)
                }
            }
            )
            ).catch(err => {
                setPracticeTopicLoading(false);
            })
    }
    function getLearningPouplarVideos(filterId: any[], id: any) {
        let payload = {
            categoryId:filterId?[...filterId]:[]
        }
        setLearningGroupIds(filterId?[...filterId]:[]);
        setLearningVideosLoading(true);
        postData(HOMEPAGE_API_CONSTANTS.LEARNING_POPULAR_VIDEOS,
            payload,
            APIEnv.NODE_PREMIUM).then((response => {
                setLearningVideosLoading(false);
                if (response?.ResponseType == APIStatus.SUCCESS) {
                    let ModifiedData = response.data?.date?.itemarray.map(createNavigationURLforLearning)
                    setlearningVideosData(ModifiedData);
                    setLearningFilterData(response.data?.date?.filter)
                }
            }
            )
            ).catch(err => {
                setLearningVideosLoading(false);
            })
    }

    function filterSelectedResearchTab(filterId: any[], tabName:string) {
        setResearchSelectedSubTab(tabName);
        let id: String = selectedTab == 0 ? OfferCategoryId?.ALL: ( selectedTab == 1 ? OfferCategoryId?.GST : OfferCategoryId?.INCOME_TAX);
        getResearchTopics(filterId, id)
    }
    function filterSelectedPracticeTab(filterId: any[], tabName: string) {
        setPracticeSelectedSubTab(tabName);
        let id: String = selectedTab == 0 ? OfferCategoryId?.ALL: ( selectedTab == 1 ? OfferCategoryId?.GST : OfferCategoryId?.INCOME_TAX);
        getPopularTopics(filterId, id)
    }
    function filterSelectedLearningTab(filterId: any[], tabName:string) {
        setLearningSelectedSubTab(tabName);
        let id: String = selectedTab == 0 ? OfferCategoryId?.ALL: ( selectedTab == 1 ? OfferCategoryId?.GST : OfferCategoryId?.INCOME_TAX);
        getLearningPouplarVideos(filterId, id)
    }
    const onClickViewAll = (type:string,filterType:string ) => {
        if (!checkIsUserLoggedIn()) {
            return `${urlPrefix + "/" + AppRouteURL.LOGIN}`;
        }
        
        const platformQuery = 'platform=premium';
        const addPlatformQueryParam = (url: string) => {
            if (url.includes('?')) {
            return `${url}&${platformQuery}`;
            } else {
            return `${url}?${platformQuery}`;
            }
        };
        
        if (type === HomePageCarouselType.RESEARCH) {
            switch (filterType) {
            case HomePageCarouselFilter.ALL:
                return addPlatformQueryParam(
                window.location.origin + viewAllUrlPaths.CASE_LAWS.ALL +
                (researchSelectedSubTab !== 'All' ? `?moduleType=${RESEARCH_MAPPINGS[researchSelectedSubTab]}` : '')
                );
            case HomePageCarouselFilter.GST:
                return addPlatformQueryParam(
                window.location.origin + viewAllUrlPaths.CASE_LAWS.GST +
                (researchSelectedSubTab !== 'All' ? `?moduleType=${RESEARCH_MAPPINGS[researchSelectedSubTab]}` : '')
                );
            case HomePageCarouselFilter.INCOME_TAX:
                return addPlatformQueryParam(
                window.location.origin + viewAllUrlPaths.CASE_LAWS.INCOME_TAX +
                (researchSelectedSubTab !== 'All' ? `?moduleType=${RESEARCH_MAPPINGS[researchSelectedSubTab]}` : '')
                );
            }
        }
        
        if (type === HomePageCarouselType.PRACTICE) {
            switch (filterType) {
            case HomePageCarouselFilter.ALL:
                return addPlatformQueryParam(
                window.location.origin + viewAllUrlPaths.PRACTICE.ALL + '&' +
                (practiceSelectedSubTab !== 'All' ? `documentType=${practiceSelectedSubTab}` : '')
                );
            case HomePageCarouselFilter.GST:
                return addPlatformQueryParam(
                window.location.origin + viewAllUrlPaths.PRACTICE.GST + '&' +
                (practiceSelectedSubTab !== 'All' ? `documentType=${practiceSelectedSubTab}` : '')
                );
            case HomePageCarouselFilter.INCOME_TAX:
                return addPlatformQueryParam(
                window.location.origin + viewAllUrlPaths.PRACTICE.INCOME_TAX + '&' +
                (practiceSelectedSubTab !== 'All' ? `documentType=${practiceSelectedSubTab}` : '')
                );
            }
        }
        
        if (type === HomePageCarouselType.VIDEO) {
            return addPlatformQueryParam(
            `${window.location.origin}/learning/events/` +
            (learningSelectedSubTab !== 'All' ? learningSelectedSubTab.toLowerCase() : '')
            );
        }
        
        return "#";
    }
    
           return (
        <>
           {window.location.pathname.includes('/premium/home') ? 
                <LoginHomePage researchTopics={researchTopics} practicePopularTopics={practicePopularTopics}  learningVideosData={learningVideosData} 
                    researchFilterData={researchFilterData} practiceFilterData={practiceFilterData} learningFilterData={learningFilterData} 
                     setSelectedTab={setSelectedTab}
                    selectedTab={selectedTab} onClickViewAll={onClickViewAll} caseLawsLoading={caseLawsLoading} 
                    filterSelectedResearchTab={filterSelectedResearchTab} filterSelectedPracticeTab={filterSelectedPracticeTab} filterSelectedLearningTab={filterSelectedLearningTab}
                    cirNotLoading={cirNotLoading} practiceTopicLoading={practiceTopicLoading} learningVideosLoading={learningVideosLoading} /> :
                <LogoutHomePage practicePopularTopics={practicePopularTopics} caseLawsData={caseLawsData} cirnotFilterData={cirnotFilterData}
                    caseLawsFilterData={caseLawsFilterData} CirNottData={CirNottData} 
                    learningVideosData={learningVideosData} 
                    setSelectedTab={setSelectedTab} selectedTab={selectedTab} onClickViewAll={onClickViewAll}
                    caseLawsLoading={caseLawsLoading} cirNotLoading={cirNotLoading} practiceTopicLoading={practiceTopicLoading} learningVideosLoading={learningVideosLoading} />}
        </>

    )
}